import { Typography } from '@one-thd/sui-atomic-components';
import { DateRangeCalendar } from '@one-thd/sui-date-pickers';
import { DateTime } from 'luxon';
import React from 'react';
import { ICustomDateRange } from '../../models/purchase-history/custom-date-range';

export const CustomDateRange = ({
  dateRangeState: { startDate, setStartDate, endDate, setEndDate },
}: ICustomDateRange) => {
  const maxDate = DateTime.now().startOf('day').toString();
  const minDate = DateTime.now()
    .minus({ months: 25 })
    .startOf('day')
    .toString();

  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      <Typography variant="body-lg">
        Select date range for Purchase History
      </Typography>

      <DateRangeCalendar
        minDate={minDate}
        maxDate={maxDate}
        value={{
          start: startDate?.toISODate() || '',
          end: endDate?.toISODate() || '',
        }}
        onChange={(_event, value) => {
          setStartDate(DateTime.fromISO(value.start));
          setEndDate(DateTime.fromISO(value.end));
        }}
      />
    </div>
  );
};
